import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class PublicDictionaryCountryCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly isoCode?: Nillable<string>;

  @jsonMember(String)
  public readonly label!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;
}
